import { render, staticRenderFns } from "./PreviewDocuments.vue?vue&type=template&id=4a0558ea&"
import script from "./PreviewDocuments.vue?vue&type=script&lang=ts&"
export * from "./PreviewDocuments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports